// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__OMX_b","containerItemsCenter":"Skeleton_containerItemsCenter__11Te9"};